import type { UseQueryResult } from '@tanstack/react-query'
import { useQuery } from '@tanstack/react-query'

import {
  GET_RESOURCES_BY_CONTROLLER_EQUIPMENT_NUMBER_API_ID,
  getResourcesByControllerEquipmentNumber,
} from '@/features/resource/endpoints/resources'
import type { Resource } from '@/features/resource/types'

export type UseResourcesByControllerEquipmentNumberQueryResult = Omit<UseQueryResult, 'data'> & {
  resources: Resource[]
}

// Stable empty-array reference so callers can rely on referential equality in useMemo / useEffect deps.
const EMPTY_RESOURCES: Resource[] = []

export function useResourcesByControllerEquipmentNumberQuery(
  controllerEquipmentNumber: number | undefined,
): UseResourcesByControllerEquipmentNumberQueryResult {
  const { data, ...queryResult } = useQuery({
    queryKey: [GET_RESOURCES_BY_CONTROLLER_EQUIPMENT_NUMBER_API_ID, controllerEquipmentNumber],
    queryFn: () => getResourcesByControllerEquipmentNumber(controllerEquipmentNumber!),
    enabled: controllerEquipmentNumber != null,
  })

  return {
    resources: data ?? EMPTY_RESOURCES,
    ...queryResult,
  }
}
